export default "__VITE_ASSET__13f143e1__"